import { 
  GET_MAP_OPTIONS
} from '../constants/index';
import { MapState, mapActions } from '../types/mapTypes';

const initialState: MapState = {
  mapOptions: {
    
  }
}

const mapReducer = (state = initialState, action: mapActions) => {
  // const payload = action.payload;

  switch(action.type){
    case GET_MAP_OPTIONS:
      return {
       ...state
      }
    
    default: 
      return state
  }
}

export default mapReducer;
